// @ts-expect-error 'value' is declared but its value is never read
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const satisfyLintIgnoreHookValue = (value: unknown) => void 0;
